import { render } from "./ClientSearch.vue?vue&type=template&id=2c7e0a96&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=js"
export * from "./ClientSearch.vue?vue&type=script&lang=js"

import "@/assets/css/table-resp.css?vue&type=style&index=0&id=2c7e0a96&scoped=true&lang=css"
import "./ClientSearch.vue?vue&type=style&index=1&id=2c7e0a96&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7e0a96"]])

export default __exports__